import * as R from "ramda";
import { getDataParams } from "./getDataParams.mjs";
import { getDataRequestQuery } from "./getDataRequestQuery.mjs";
import { getRequestHeaders } from "./getRequestHeaders.mjs";
import { getStructureParams } from "./getStructureParams.mjs";
import { getStructureRequestQuery } from "./getStructureRequestQuery.mjs";
import { isDataRequest } from "./isDataRequest.mjs";
const getRequestQuery = ({ type, identifiers, dataquery }) => R.ifElse(
  isDataRequest,
  getDataRequestQuery,
  getStructureRequestQuery
)({
  type,
  identifiers,
  dataquery
});
const getRequestArgs = (args) => {
  const datasourceUrl = R.path(["datasource", "url"], args);
  const url = `${datasourceUrl}/${getRequestQuery(args)}`;
  const headers = getRequestHeaders(args);
  const params = R.ifElse(
    isDataRequest,
    getDataParams,
    getStructureParams
  )(args);
  return { url, headers, params };
};
export {
  getRequestArgs
};
